<template lang="pug">
  div
    .modal-card(style='width: auto')
      header.modal-card-head
        p.modal-card-title Generations
      section.modal-card-body
        .content
          p Filter the pokedex by selecting one of the generations/regions.
          p Shows pokemon for that generation/region.
      footer.modal-card-foot
        button.button(type='button', @click='$parent.close()') Close
</template>

<script>
export default {
  name: 'GenerationsHelp',
};
</script>

<style lang="scss" scoped></style>
